<template>
  <h5 class="back-closd-link">
    <a :href="$t('login.BackToClosd.urlClosd')" data-locator="back-to-closd-link">
      {{$t('login.BackToClosd.backClosd')}}
    </a>
  </h5>
</template>

<script>
export default {
  name: 'BackToClosd',
}
</script>

<style scoped>
.back-closd-link a{
    text-decoration: none;
    color: #9e9e9e
}
</style>
